import axios from 'axios';
import { API_URL } from './api-config';

// Dedicated axios instance for actuator calls. Spring Boot's /actuator/info and
// /actuator/health are public, so we avoid the main `api` instance to skip the
// Token header injection — that header triggers a CORS preflight and some
// gateways (e.g. SAC) don't allow `Token` in Access-Control-Allow-Headers.
const apiActuator = axios.create({
  baseURL: API_URL,
  timeout: 15000,
  headers: { Accept: 'application/json' },
});

export interface ActuatorInfo {
  build?: {
    artifact?: string;
    name?: string;
    time?: string;
    version?: string;
    group?: string;
  };
  git?: {
    branch?: string;
    commit?: {
      id?: string;
      'id.abbrev'?: string;
      time?: string;
    };
  };
  [key: string]: unknown;
}

export type ActuatorHealthStatus = 'UP' | 'DOWN' | 'OUT_OF_SERVICE' | 'UNKNOWN';

export interface ActuatorHealth {
  status: ActuatorHealthStatus;
  components?: Record<string, { status: ActuatorHealthStatus; details?: Record<string, unknown> }>;
}

export const getActuatorInfo = (servicePath: string) =>
  apiActuator.get<ActuatorInfo>(`${servicePath}/actuator/info`);

export const getActuatorHealth = (servicePath: string) =>
  apiActuator.get<ActuatorHealth>(`${servicePath}/actuator/health`);
